import ajax from "./ajax";

// ─── Phone-based (legacy) ────────────────────────────────────────────────────

export function signUpRequest(params) {
  return ajax("/customers", { method: "POST", data: params });
}

export function verifyOtp(params) {
  return ajax("/customers/verify_mobile_otp", { method: "POST", data: params });
}

export function login(params) {
  return ajax("/customers/login", { method: "POST", data: params });
}

export function updateProfile(params) {
  return ajax(`/customers/update_customer`, { method: "POST", data: params });
}

export function getCustomerDetails(userId) {
  return ajax(`/customers/${userId}`);
}

export function forgetPassword(params) {
  return ajax("/customers/forgot_password", { method: "POST", data: params });
}

export function forgetPasswordOtpCheck(params) {
  return ajax("/customers/verify_forgot_password_otp", {
    method: "POST",
    data: params,
  });
}

export function changePassword(params) {
  return ajax("/customers/change_password", { method: "POST", data: params });
}

// ─── Email-based ─────────────────────────────────────────────────────────────

// Sign up a new customer using email address.
export function signUpWithEmail(params) {
  return ajax("/customers", { method: "POST", data: params });
}

// Verify the email OTP sent after signup.
export function verifyEmailOtp(params) {
  return ajax("/customers/verify_email_otp", { method: "POST", data: params });
}

// Login using email address and password.
export function loginWithEmail(params) {
  return ajax("/customers/login_using_email", { method: "POST", data: params });
}

// Send a forgot-password OTP to the customer's email.
export function forgotEmailPassword(params) {
  return ajax("/customers/forgot_email_password", {
    method: "POST",
    data: params,
  });
}

// Verify the forgot-password OTP sent to email.
export function verifyEmailForgotPasswordOtp(params) {
  return ajax("/customers/verify_email_forgot_password_otp", {
    method: "POST",
    data: params,
  });
}
